export default __webpack_public_path__ + "static/media/detail_big_11_3.32d1024e.jpg";